require('./dist/page-notice/page-notice.css');
